import React from "react";

import {
	Box,
	Stack,
	Typography,
} from "@mui/material";

import SubscribeService from "services/subscribe-service";

import { Trans } from "@lingui/macro";
import { SubscribeState } from "./models";
import SubscriptionCard from "components/subscribe/subscription-card/subscription-card";

import ZPlayLoader from "commons/zplay-loader";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";

export class Subscribe extends React.Component<{}, SubscribeState>
{
	constructor(props: any) {
		super(props);

		this.state = {
			isLoading: true,
			subscriptionList: null
		};
	}

	componentDidMount() {
		SubscribeService.getAllAvailableSubscription(this.successCallback, this.errorCallback);
	}

	private successCallback = (data: any) => {

		this.setState(() => ({
			isLoading: false,
			subscriptionList: data.list
		}));
	};

	private errorCallback = (err: any) => {
		this.setState(() => ({ isLoading: false }));
		console.log(err);
	};

	handleBuyClick = (id: string) => {
		this.setState(() => ({ isLoading: true }));
		SubscribeService.activateSubscription(id, this.buySuccessCallback, this.buyErrorCallback);
	};

	buySuccessCallback = (data: any) => {

		this.setState(() => ({ isLoading: false }));

		window.location.replace(data.url);
	};

	buyErrorCallback = (err: any) => {
		this.setState(() => ({ isLoading: false }));
		console.log(err);
	};

	render() {
		return (<Box
			sx={{
				p: 5
			}}	>
			<NavigationBack backRoute="/" />
			<Box sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center"
			}}>
				<Typography variant="h1" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR} textTransform="uppercase" display="inline">
					<Trans id="sub-title-1">Scegli il tuo</Trans> <Typography variant="h1" color={process.env.REACT_APP_PRIMARY_COLOR} textTransform="uppercase" display="inline"><Trans id="sub-title-2">Abbonamento</Trans></Typography>
				</Typography>
				<Typography variant="h3" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR} justifyContent={"center"} sx={{ mt: 2, fontSize: 20 }}>
					<Trans id="sub-subtitle-3">Abbonati per iniziare a fruire subito della piattaforma</Trans>
				</Typography>
				{!this.state.isLoading && <Stack direction={"row-reverse"} spacing={17} sx={{ mt: 12 }}>
					{this.state.subscriptionList?.map(
						(item) => (<SubscriptionCard product={item} key={item.id} onClickHandler={this.handleBuyClick} />))}
				</Stack>}
				{this.state.isLoading && <ZPlayLoader />}
			</Box>
		</Box>);
	}
}
